import React from 'react';
import PropTypes from 'prop-types';
import { Breadcrumbs, ChartsWrapper } from './TopLegalVendors.styles';
import CostPerLawyer from '../Charts/CostPerLawyer';
import CostPerLawyerByFirmName from '../Charts/CostPerLawyerByFirmName';

const TopLegalVendors = ({ setCurrentContent, label }) => {
	return (
		<>
			<Breadcrumbs>
				<span onClick={() => setCurrentContent(0)}>Category Widgets</span>&nbsp;/&nbsp;<span
				>
					{label}
				</span>
			</Breadcrumbs>
			<ChartsWrapper>
				<CostPerLawyer chartTitle="Cost Per Lawyer" />
				<CostPerLawyerByFirmName chartTitle="Cost Per Lawyer By Firm Name" />
			</ChartsWrapper>
		</>
	);
};

TopLegalVendors.propTypes = {
	setCurrentContent: PropTypes.func.isRequired,
	label: PropTypes.string.isRequired,
};

export default TopLegalVendors;
